export enum AppIntegrationFeature {
  MediaCapture = 'mediaCapture',
  CreatePrescription = 'createPrescription',
}
